import React, { useState, useEffect } from "react";
import { getDatabase, ref, get, update } from "firebase/database";
import { getAuth } from "firebase/auth";
import { Trophy, CheckCircle, X, Info } from "lucide-react";

const AlertPayPromo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showCurrencyInfo, setShowCurrencyInfo] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const db = getDatabase();
    const user = auth.currentUser;

    if (user) {
      const userRef = ref(db, `usuarios/${user.uid}`);
      get(userRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setUserData(data);
          // Si es cuenta gratis, mostrar el modal
          if (data.typeU === "Cuenta Gratis") {
            setIsOpen(true);
          }
        }
      });
    }
  }, []);

  const handleJoinGroup = () => {
    const auth = getAuth();
    const db = getDatabase();
    const user = auth.currentUser;

    if (user) {
      setIsSubmitting(true);
      const userRef = ref(db, `usuarios/${user.uid}`);
      update(userRef, { Promocion40: true })
        .then(() => {
          setIsSubmitting(false);
          setSuccess(true);
          setTimeout(() => {
            setIsOpen(false);
          }, 5000);
        })
        .catch((error) => {
          setIsSubmitting(false);
          console.error("Error al actualizar el estado:", error);
        });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 animate-fadeIn p-4">
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-4 sm:p-6 rounded-xl shadow-xl border border-yellow-500 w-full max-w-md transform transition-all duration-300 ease-in-out">
        {!success ? (
          <>
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center">
                <Trophy className="text-yellow-500 mr-2" size={24} />
                <h2 className="text-xl sm:text-2xl font-bold text-white">
                  GRAN PROMOCIÓN
                </h2>
              </div>
              <div className="bg-yellow-500 text-black px-2 py-1 rounded-full text-xs font-bold animate-pulse">
                EXCLUSIVO
              </div>
            </div>
            <div className="bg-gray-800 p-3 sm:p-4 rounded-lg mb-4 border-l-4 border-yellow-500">
              <h3 className="text-lg sm:text-xl font-bold text-white">
                ¡Hola {userData?.name || "Usuario"}! 👋
              </h3>
              <p className="mt-2 text-gray-300 text-base sm:text-lg">
                🚀{" "}
                <span className="text-yellow-500 font-bold">
                  ¡Oferta exclusiva para ti!
                </span>{" "}
                Como miembro{" "}
                <span className="text-yellow-500 font-bold">GRATIS</span>,
                desbloquea un
                <span className="text-green-400 font-bold">
                  {" "}
                  increíble 40% de descuento
                </span>
                .
              </p>
              <div className="mt-2">
                <p className="text-gray-300 text-base sm:text-lg">
                  💰 Precio original:{" "}
                  <span className="line-through text-red-500">$55.000 COP</span>
                </p>
                <p className="text-green-400 text-xl sm:text-2xl font-bold flex items-center">
                  🔥 ¡Ahora por solo $33.000 COP!
                  <button
                    onClick={() => setShowCurrencyInfo(!showCurrencyInfo)}
                    className="ml-2 text-xs bg-gray-700 hover:bg-gray-600 rounded-full p-1"
                    aria-label="Información sobre moneda"
                  >
                    <Info size={16} />
                  </button>
                </p>
                {showCurrencyInfo && (
                  <div className="mt-2 p-2 bg-gray-700 rounded-lg text-xs text-gray-300">
                    Los precios están en Pesos Colombianos (COP). No te
                    preocupes por la moneda, al momento de pagar podrás ver el
                    precio equivalente en tu moneda local.
                  </div>
                )}
              </div>
              <p className="mt-2 text-gray-300 text-base sm:text-lg">
                ⏳ ¡Date prisa! Los cupos son{" "}
                <span className="text-red-500 font-bold">limitados</span>.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row sm:justify-between gap-2 sm:items-center">
              <button
                onClick={() => setIsOpen(false)}
                className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-all duration-200 order-2 sm:order-1"
              >
                Omitir
              </button>
              <a
                href="https://checkout.bold.co/payment/LNK_F7065S8AII"
                target="_blank"
                rel="noopener noreferrer"
                className={`bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-6 py-2 rounded-lg transition-all duration-200 flex items-center justify-center order-1 sm:order-2 ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={handleJoinGroup}
              >
                {isSubmitting ? (
                  <span className="inline-block w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin mr-2"></span>
                ) : null}
                Comprar ahora
              </a>
            </div>

            <div className="mt-4 text-xs text-gray-400 text-center">
              Recibe pronósticos exclusivos y mejora tus estrategias de apuestas
            </div>
          </>
        ) : (
          <div className="text-center py-8 flex flex-col items-center">
            <div className="bg-green-500 p-4 rounded-full mb-4 animate-bounce">
              <CheckCircle className="text-white" size={32} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              ¡Estamos validando!
            </h3>
            <p className="text-gray-300">
              Ahora recibirás ayuda del soporte si es necesario.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertPayPromo;
